import gql from 'graphql-tag';

export const ShopFragmentMainEndpoint = gql`
  fragment ShopFragmentMainEndpoint on ShopModel {
    id
    identify
    opens_soon
    icon_list
    icon_map
    review_widget
    title
    type
    address
    ya_maps_url
    phone
    yandex_reserve
    schedule {
      days
      hours
      status
    }
    geo
    images {
      file_webp
      file
    }
    images_landing {
      tempFullFilePath
      title
    }
    attachments {
      description
      weight
      type
      attachmentsItem {
        file_webp
        tempFullFilePath
      }
    }
    metroStations {
      id
      title
      line {
        id
        title
        color
      }
    }
  }
`;
